(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lw-shell"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.LittleWonderCart?.ready) return;
    const dialog = document.getElementById('lw-cart-dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const text = JSON.parse(dialog.querySelector('[data-lw-cart-translations]').textContent);
    const main = dialog.querySelector('[data-lw-cart-main]');
    const checkout = dialog.querySelector('[data-lw-cart-checkout]');
    const error = dialog.querySelector('[data-lw-cart-error]');
    const status = dialog.querySelector('[data-lw-cart-status]');
    let currentCart = null;
    let changing = false;
    let loadVersion = 0;
    let pendingFocus = null;
    document.body.classList.add('lw-js');
    const make = (tag, className, content) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (content !== undefined) element.textContent = content;
      return element;
    };
    const safeUrl = (value, fallback) => {
      try { const url = new URL(value, location.origin); return ['https:', 'http:'].includes(url.protocol) ? url.href : fallback; } catch { return fallback; }
    };
    const money = value => new Intl.NumberFormat(dialog.dataset.locale || 'en-US', { style: 'currency', currency: currentCart?.currency || dialog.dataset.currency || 'USD' }).format(Number(value || 0) / 100);
    const showError = message => { error.textContent = message; error.hidden = !message; };
    const lockScroll = () => document.body.classList.toggle('lw-dialog-open', Boolean(document.querySelector('[data-lw-dialog][open]')));
    const showDialog = target => {
      document.querySelectorAll('[data-lw-dialog][open]').forEach(open => { if (open !== target) open.close(); });
      if (!target.open) target.showModal();
      lockScroll();
    };
    const updateCounts = cart => document.querySelectorAll('[data-lw-cart-count]').forEach(count => { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; });
    const setBusy = busy => {
      main.setAttribute('aria-busy', String(busy));
      dialog.querySelectorAll('[data-lw-cart-change], [data-lw-cart-quantity], [data-lw-cart-checkout-button]').forEach(control => {
        if (busy) { if (!('lwBusyDisabled' in control.dataset)) control.dataset.lwBusyDisabled = String(control.disabled); control.disabled = true; }
        else if ('lwBusyDisabled' in control.dataset) { control.disabled = control.dataset.lwBusyDisabled === 'true'; delete control.dataset.lwBusyDisabled; }
      });
    };
    const render = cart => {
      if (!cart || !Array.isArray(cart.items)) return;
      const focused = document.activeElement;
      const focusedLine = pendingFocus?.key || focused?.closest('[data-lw-cart-line]')?.dataset.lwCartLine;
      const focusAction = pendingFocus?.action || focused?.dataset.lwCartAction;
      currentCart = cart;
      updateCounts(cart);
      main.replaceChildren();
      checkout.hidden = cart.item_count === 0;
      if (!cart.items.length) {
        const empty = make('div', 'lw-cart-empty');
        empty.append(make('h3', '', text.empty), make('p', '', text.emptyNote));
        const link = make('a', 'lw-button', text.continue);
        link.href = text.collectionUrl;
        empty.append(link);
        main.append(empty);
      }
      cart.items.forEach(item => {
        const row = make('article', 'lw-cart-line');
        row.dataset.lwCartLine = item.key;
        const imageLink = make('a', 'lw-cart-image');
        imageLink.href = safeUrl(item.url, dialog.dataset.cartUrl);
        imageLink.tabIndex = -1;
        imageLink.setAttribute('aria-hidden', 'true');
        if (item.image) { const image = make('img'); image.src = safeUrl(item.image, ''); image.alt = ''; image.width = 180; image.height = 200; image.loading = 'lazy'; imageLink.append(image); }
        const info = make('div', 'lw-cart-line-info');
        const title = make('a', 'lw-cart-product-title', item.product_title || item.title);
        title.href = safeUrl(item.url, dialog.dataset.cartUrl);
        info.append(title);
        if (item.variant_title && item.variant_title !== 'Default Title') info.append(make('p', 'lw-cart-variant', item.variant_title));
        const publicProperties = Object.entries(item.properties || {}).filter(([key, value]) => !key.startsWith('_') && value);
        publicProperties.forEach(([key, value]) => info.append(make('p', 'lw-cart-variant', `${key}: ${value}`)));
        if (item.selling_plan_allocation?.selling_plan?.name) info.append(make('p', 'lw-cart-variant', item.selling_plan_allocation.selling_plan.name));
        const price = make('p', 'lw-cart-line-price');
        price.append(make('span', '', money(item.final_line_price)));
        if (item.original_line_price > item.final_line_price) price.append(make('s', '', money(item.original_line_price)));
        info.append(price);
        const controls = make('div', 'lw-cart-line-controls');
        const quantity = make('div', 'lw-cart-quantity');
        const rule = item.quantity_rule || {};
        const step = Number(rule.increment) || 1;
        const minimum = Number(rule.min) || 1;
        const maximum = Number(rule.max) || Infinity;
        const minus = make('button', '', '−');
        minus.type = 'button'; minus.dataset.lwCartChange = item.key; minus.dataset.lwCartAction = 'decrease'; minus.dataset.quantity = Math.max(0, item.quantity - step); minus.disabled = item.quantity <= minimum; minus.setAttribute('aria-label', `${text.decrease} ${item.product_title || item.title}`);
        const input = make('input');
        input.type = 'number'; input.inputMode = 'numeric'; input.min = minimum; input.step = step; if (Number.isFinite(maximum)) input.max = maximum; input.value = item.quantity; input.dataset.lwCartQuantity = item.key; input.dataset.lwCartAction = 'quantity'; input.setAttribute('aria-label', `${text.quantity} ${item.product_title || item.title}`);
        const plus = make('button', '', '+');
        plus.type = 'button'; plus.dataset.lwCartChange = item.key; plus.dataset.lwCartAction = 'increase'; plus.dataset.quantity = item.quantity + step; plus.disabled = item.quantity + step > maximum; plus.setAttribute('aria-label', `${text.increase} ${item.product_title || item.title}`);
        quantity.append(minus, input, plus);
        const remove = make('button', 'lw-cart-remove', text.remove);
        remove.type = 'button'; remove.dataset.lwCartChange = item.key; remove.dataset.lwCartAction = 'remove'; remove.dataset.quantity = 0; remove.setAttribute('aria-label', `${text.remove} ${item.product_title || item.title}`);
        controls.append(quantity, remove); info.append(controls); row.append(imageLink, info); main.append(row);
      });
      dialog.querySelector('[data-lw-cart-subtotal]').textContent = money(cart.total_price);
      dialog.querySelector('[data-lw-cart-discounts]').textContent = `−${money(cart.total_discount)}`;
      dialog.querySelector('[data-lw-cart-saving]').hidden = !cart.total_discount;
      dialog.querySelector('[data-lw-cart-shipping]').textContent = cart.taxes_included ? text.shippingIncluded : text.shipping;
      main.setAttribute('aria-busy', 'false');
      dialog.querySelector('[data-lw-cart-checkout-button]').disabled = false;
      if (dialog.open && focusedLine && focusAction) {
        const newLine = Array.from(main.querySelectorAll('[data-lw-cart-line]')).find(line => line.dataset.lwCartLine === focusedLine);
        const nextFocus = newLine?.querySelector(`[data-lw-cart-action="${focusAction}"]`);
        if (nextFocus && !nextFocus.disabled) nextFocus.focus({ preventScroll: true });
        else dialog.querySelector('[data-lw-close-dialog]').focus({ preventScroll: true });
      }
      pendingFocus = null;
    };
    const readCart = async () => {
      const response = await fetch(dialog.dataset.cartJsonUrl, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error(text.loadError);
      return response.json();
    };
    const openCart = async () => {
      const version = ++loadVersion;
      showDialog(dialog);
      showError('');
      setBusy(true);
      try { const cart = await readCart(); if (version === loadVersion && !changing) render(cart); }
      catch { if (version === loadVersion) { showError(text.loadError); if (!currentCart) { const link = make('a', 'lw-button', text.viewCart); link.href = dialog.dataset.cartUrl; main.replaceChildren(link); } } }
      finally { if (version === loadVersion && !changing) setBusy(false); }
    };
    const changeQuantity = async (key, quantity) => {
      if (changing) return;
      if (!Number.isInteger(quantity) || quantity < 0) { showError(text.quantityError); return; }
      changing = true;
      loadVersion += 1;
      pendingFocus = { key, action: document.activeElement?.dataset.lwCartAction || 'quantity' };
      showError('');
      setBusy(true);
      try {
        const response = await fetch(dialog.dataset.cartChangeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
        const cart = await response.json();
        if (!response.ok || !Array.isArray(cart.items)) throw new Error(cart.description || cart.message || text.error);
        render(cart);
        status.textContent = text.updated;
        document.dispatchEvent(new CustomEvent('lw:cart-updated', { detail: { cart, source: 'cart' } }));
      } catch (failure) {
        showError(failure.message || text.error);
        try { render(await readCart()); } catch {}
      } finally { changing = false; setBusy(false); }
    };
    document.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const cartTrigger = target.closest('[data-lw-open-cart]');
      if (cartTrigger) {
        if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); openCart(); return;
      }
      const menuTrigger = target.closest('[data-lw-open-menu]');
      if (menuTrigger) { const menu = document.getElementById(menuTrigger.dataset.lwOpenMenu); if (menu) showDialog(menu); return; }
      const close = target.closest('[data-lw-close-dialog]');
      if (close) { close.closest('dialog')?.close(); return; }
      if (target.matches('[data-lw-dialog]')) {
        const bounds = target.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) target.close();
        return;
      }
      const change = target.closest('[data-lw-cart-change]');
      if (change && dialog.contains(change)) changeQuantity(change.dataset.lwCartChange, Number(change.dataset.quantity));
      const menuLink = target.closest('.lw-mobile-links a');
      if (menuLink) menuLink.closest('dialog')?.close();
    });
    document.addEventListener('change', event => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.matches('[data-lw-cart-quantity]')) return;
      if (!input.checkValidity() || input.value.trim() === '') { showError(text.quantityError); render(currentCart); return; }
      changeQuantity(input.dataset.lwCartQuantity, Number(input.value));
    });
    document.addEventListener('close', event => { if (event.target.matches?.('[data-lw-dialog]')) lockScroll(); }, true);
    document.addEventListener('lw:cart-updated', event => {
      const { cart, source } = event.detail || {};
      if (!cart || !Array.isArray(cart.items)) return;
      loadVersion += 1;
      if (source !== 'cart') { showError(''); render(cart); showDialog(dialog); }
      else updateCounts(cart);
    });
    document.addEventListener('shopify:section:unload', () => requestAnimationFrame(lockScroll));
    checkout.addEventListener('submit', event => { if (changing || main.getAttribute('aria-busy') === 'true') event.preventDefault(); });
    window.LittleWonderCart = { ready: true, open: openCart, refresh: async () => render(await readCart()) };
  })();
  } catch(e) { console.error(e); }
})();

})();
